<template>
  <div id="userApplicationComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="userApplicationSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search"
        >
        </v-text-field>
        <v-dialog persistent v-model="dialog" max-width="700px">
          <v-btn slot="activator" color="primary" round outline>
            <v-icon left>people</v-icon>
            {{ $t('userApplication.add') }}
          </v-btn>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ $t('userApplication.add') }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-alert
                    :value="error"
                    color="error"
                    icon="warning"
                    outline
                    transition="scale-transition"
                  >
                    {{ errorMessage }}
                  </v-alert>
                  <v-container>
                    <v-form
                      lazy-validation
                      ref="form"
                      v-model="valid"
                      v-if="editedItem"
                    >
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-autocomplete
                            v-model="editedItem.user"
                            :label="$t('general.user')"
                            :items="userList"
                            item-text="name"
                            item-value="id"
                            :rules="rules.required"
                            :error-messages="errors.user_id"
                            return-object
                          >
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete
                            v-model="editedItem.application"
                            :label="$t('general.application')"
                            :items="applications"
                            item-text="name"
                            item-value="id"
                            :rules="rules.required"
                            :error-messages="errors.application_id"
                            return-object
                          >
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" round flat depressed @click="close">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                round
                depressed
                :loading="loading"
                :disabled="loading"
                @click="validate($event)"
              >
                {{ $t('general.submit') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogdelete" max-width="500px">
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black error--text mb-0">
                {{ $t('userApplication.delete') }}
              </h2>
            </v-toolbar>
            <!-- <v-card-text v-if="userLogged.roles[0].id === 1">
                {{ $t('general.deleteElementQuestion') }}
                <p v-if="editedItem.user !== null" class="font-weight-black">
                  {{ $t('userApplication.relationshipOfUser') + ' ' + removedItem.user.name + ' ' + $t('userApplication.withApplication') + ' ' + removedItem.application.name }}
                </p>
              </v-card-text> -->
            <v-card-text>
              {{ $t('general.deleteElementQuestion') }}
              <p v-if="removedItem.user !== null" class="font-weight-black">
                {{
                  $t('userApplication.relationshipOfUser') +
                  ' ' +
                  removedItem.user.name +
                  ' ' +
                  $t('userApplication.withApplication') +
                  ' ' +
                  removedItem.user.application.name
                }}
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" round flat depressed @click="closeDelete">{{
                $t('general.cancel')
              }}</v-btn>
              <v-btn color="error" round depressed @click="confirmDelete">{{
                $t('general.delete')
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- <v-data-table
        v-if="userLogged.roles[0].id === 1"
        :headers="headers"
        :items="processedUserApplications"
        class="elevation-1"
        :pagination.sync="pagination">
        <template v-slot:headers="props">
          <tr class="primary">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['font-weight-black white--text column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header)"
              >
              <h2>
                <v-icon small class="white--text" v-if="header.sortable">arrow_upward</v-icon>
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.user.name }}</td>
          <td class="text-xs-center">{{ props.item.user.email }}</td>
          <td class="text-xs-center">{{ props.item.application.name }}</td>
          <td class="justify-center layout px-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  outline
                  icon
                  color="error"
                  v-on="on"
                  @click="deleteItemDialog(props.item)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('general.delete') }}</span>
            </v-tooltip>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="get">{{ $t('general.reset') }}</v-btn>
        </template>
      </v-data-table> -->
      <v-data-table
        :search="userApplicationSearch"
        :headers="headers"
        :items="FilterUsers"
        class="elevation-1"
        :rows-per-page-items="[10, 15, 25]"
        :pagination.sync="pagination"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column',
                header.sortable ? 'sortable' : '',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.user.name }}</td>
          <td class="text-xs-center">{{ props.item.user.email }}</td>
          <td class="text-xs-center">{{ props.item.user.application.name }}</td>
          <td class="justify-center layout px-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  outline
                  icon
                  color="error"
                  v-on="on"
                  @click="deleteItemDialog(props.item)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('general.delete') }}</span>
            </v-tooltip>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="get">{{ $t('general.reset') }}</v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'userApplicationComponent',
  data: () => ({
    userApplicationSearch: '',
    valid: false,
    error: false,
    errors: {}, // to show errors from backend
    errorMessage: '',
    timeout: 6000,
    showMessage: false,
    showPass: false,
    message: '',
    messageQueue: [],
    loading: false,
    dialog: false,
    dialogdelete: false,
    userApplications: [],
    companyUsersApp: [],
    userLogged: {
      roles: [
        {
          id: null,
        },
      ],
      company: [
        {
          id: null,
        },
      ],
    },
    users: [],
    applications: [],
    processedUserApplications: [],
    user: null,
    editedIndex: -1,
    editedItem: {
      user: null,
      application: null,
    },
    removedItem: {
      user: null,
      application: null,
    },
    defaultItem: {
      user: null,
      application: null,
    },
    pagination: {
      descending: false,
      page: 0,
      rowsPerPage: 15, // -1 for All",
      totalItems: 0,
    },
    menu: false,
  }),
  computed: {
    heading() {
      return this.$t('general.userApplication')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fas fa-user-shield fa-fw icon-color'
    },
    userList() {
      return this.users.filter(
        (item) => item.company[0].id === this.userLogged.company[0].id
      )
    },
    FilterUsers() {
      let users = []
      for (let i = 0; i < this.companyUsersApp.length; i++) {
        const item = this.companyUsersApp[i]
        if (item.user !== null) {
          if (item.user.application !== undefined) {
            if (!Array.isArray(item.user.application)) {
              users.push(item)
            }
          }
        }
      }
      return users
    },
    headers() {
      return [
        {
          text: this.$t('general.user'),
          align: 'left',
          sortable: true,
          value: 'user.name',
        },
        {
          text: this.$t('general.email'),
          align: 'left',
          sortable: true,
          value: 'user.email',
        },
        {
          text: this.$t('general.application'),
          align: 'left',
          sortable: true,
          value: 'application.name',
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ]
    },
    rules() {
      return this.$validationRules()
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
      this.$refs.form.resetValidation()
    },
    userLogged() {
      if (this.userLogged.company !== undefined) {
        this.$emit('getCompanyAppUsers', {
          id: this.userLogged.company[0].id,
          context: this,
        })
      }
    },
  },
  created() {
    this.get()
  },
  updated() {
    this.userLogged = this.$store.state.userLogged
  },
  methods: {
    changeSort(header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    },
    process() {
      var pua = []
      this.userApplications.forEach(function (element) {
        if (element.users.length) {
          element.users.forEach(function (user) {
            let processedUserApp = {}
            processedUserApp.user = user
            processedUserApp.application = element
            pua.push(processedUserApp)
          })
        }
      })
      this.processedUserApplications = pua
    },
    validate() {
      this.error = false
      if (this.$refs.form.validate()) {
        this.loading = true
        this.post()
      }
    },
    editItem(item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItemDialog(item) {
      if (item !== undefined) {
        this.editedIndex = this.FilterUsers.indexOf(item)
        this.removedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      }
      this.dialogdelete = true
    },
    confirmDelete() {
      this.delete(this.removedItem, this.editedIndex)
      this.closeDelete()
      this.close()
    },
    closeDelete() {
      this.dialogdelete = false
      this.loading = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    close() {
      this.dialog = false
      this.loading = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.errors = {}
    },
    get() {
      this.$emit('get', {
        context: this,
      })
    },
    post() {
      this.$emit('post', {
        item: this.editedItem,
        context: this,
      })
    },
    delete(item, index) {
      this.$emit('delete', {
        item: item,
        context: this,
      })
    },
    refresh() {
      this.$emit('getCompanyAppUsers', {
        id: this.userLogged.company[0].id,
        context: this,
      })
    },
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/user.application.component.vue